
//include any "progressive enhancements" - these will look for markup on the page
require('./modules/accreditation.js');
require('./modules/address-lookup.js');
require('./modules/advert.js');
require('./modules/collapsing-containers.js');
require('./modules/common.js');
require('./modules/copy-to-clipboard.js');
require('./modules/details.js');
require('./modules/disable-on-submit.js');
require('./modules/external-link-tracking.js');
require('./modules/front-end-validation.js');
require('./modules/handle-cookie.js');
require('./modules/main-navigation.js');
require('./modules/recaptcha.js');
require('./modules/sidebar.js');
require('./modules/swap-content.js');
require('./modules/wysiwyg.js');

//include any logic for our page components
require('./components/algolia-search.js');
require('./components/card-grid.js');
require('./components/domna-enquiry-form.js');
require('./components/domna-product-form.js');
require('./components/homepage-banner.js');
require('./components/ikea-service-information.js');
require('./components/join-page-hero.js');
require('./components/letter-to-mp.js');
require('./components/news-slider.js');
require('./components/newsletter-button.js');
require('./components/online-advice-new-enquiry-form.js');
require('./components/password-toggle.js');
require('./components/recognised-suppliers.js');
require('./components/search-auto-complete.js');
require('./components/service-button-bunk-portfolio.js');
require('./components/service-button-deposit-guard-custodial.js');
require('./components/service-button-deposit-guard-insured.js');
require('./components/service-button-homebox.js');
require('./components/service-button-mydeposits.js');
require('./components/service-button-tenant-referencing.js');
require('./components/service-button-title-guardian.js');
require('./components/service-button-total-landlord-insurance.js');
require('./components/star-rating.js');
require('./components/survey.js');
require('./components/tabs.js');
require('./components/training-booking-form.js');
require('./components/training-booking-panel.js');
require('./components/training-search.js');

//include the custom elements
require('./custom-elements/table-quick-search.js');
